import { checkIfProductionEnvironment } from 'src/lib/checkIfProductionEnvironment'

export const serviceUnreachableHint = (): string =>
  checkIfProductionEnvironment()
    ? 'Reload the page. If it keeps happening, let the product team know.'
    : 'Check that advanced/service is running on port 3100, then reload.'
